const getSortParamsFromString = (sortOption: string): string[] => {

  return sortOption.split(',').map(param => param.trim());

};

export default getSortParamsFromString;
